import { Container } from '@mui/material'
import React, { useCallback, useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import FireIcon from 'pages/GamesList/components/DailyStreakView/FireIcon'
import AuthContext from '../../../../context/AuthContext'
import { GamesHeaderUserIcon } from '../../../../utils/icons'

import './index.css'
import PointInput from '../../../PointInput'
import NativeAppContext from 'context/NativeApp/NativeAppContext'
import { checkDailyStreakVisibility } from 'utils/dailyStreak'

const Header = () => {
  const navigate = useNavigate()
  const { user } = useContext(AuthContext)
  const { nativeAppDetails } = useContext(NativeAppContext)

  const redirectToBalance = () => navigate('/profile/balance')

  const redirectToSettings = () => navigate('/profile/settings')

  const redirectToGames = () => navigate('/games')

  const checkDSVisibility = useCallback(
    () => checkDailyStreakVisibility(nativeAppDetails?.versionCode),
    [nativeAppDetails?.versionCode]
  )

  return (
    <header className="gamesHeader">
      <Container maxWidth="sm" sx={styles.container}>
        <img src="/logo.png" className="gamesHeaderLogo" onClick={redirectToGames} />
        <img
          src="/images/playbackLogo.png"
          className="gamesHeaderLogoBig"
          onClick={redirectToGames}
        />
        <div className="gamesHeaderActions">
          <div className="gamesHeaderInputs">
            {checkDSVisibility() && (
              <div className="fire-icon">
                <FireIcon type="enabled" value={user?.dailyStreak?.streakCount || 0} isHeader />
              </div>
            )}
            <PointInput
              onClick={redirectToBalance}
              isPig={true}
              points={user?.piggyBanks}
              customInnerClassName="gamesHeaderInputInner"
              customClassName="gamesHeaderInput"
              formatInKMB
            />
            <PointInput
              onClick={redirectToBalance}
              isPig={false}
              points={user?.points}
              customInnerClassName="gamesHeaderInputInner"
              customClassName="gamesHeaderInput"
              formatInKMB
            />
          </div>
          <div className="gamesHeaderUserIcon" onClick={redirectToSettings}>
            <GamesHeaderUserIcon />
          </div>
        </div>
      </Container>
    </header>
  )
}

const styles = {
  value: {
    fontWeight: 700,
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    height: '60px',
  },
}

export default Header
